import { render, staticRenderFns } from "./PageStatements.vue?vue&type=template&id=2bdd9f0c&scoped=true&"
import script from "./PageStatements.vue?vue&type=script&lang=ts&"
export * from "./PageStatements.vue?vue&type=script&lang=ts&"
import style0 from "./PageStatements.vue?vue&type=style&index=0&id=2bdd9f0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdd9f0c",
  null
  
)

export default component.exports